import { ReactNode } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import "./OverflowMenu.css";

export interface OverflowMenuItem {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Shown as a native tooltip on the item — typically the reason it's disabled. */
  title?: string;
  tone?: "default" | "danger";
  icon?: ReactNode;
}

/** Compact per-row "..." action trigger (table row-actions columns) — Radix
 * DropdownMenu handles positioning, outside-click/Escape dismiss, and
 * keyboard navigation for free, same reasoning as Modal's own Radix Dialog
 * wrapper. */
export function OverflowMenu({ items, triggerLabel }: { items: OverflowMenuItem[]; triggerLabel: string }) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button type="button" className="nx-overflow-menu__trigger" aria-label={triggerLabel}>
          <MoreHorizontal size={16} />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="nx-overflow-menu__content" align="end" sideOffset={4}>
          {items.map((item) => (
            <DropdownMenu.Item
              key={item.key}
              className={["nx-overflow-menu__item", item.tone === "danger" ? "nx-overflow-menu__item--danger" : ""]
                .filter(Boolean)
                .join(" ")}
              disabled={item.disabled}
              title={item.title}
              onSelect={item.onClick}
            >
              {item.icon}
              {item.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
